import Axios from 'axios'
import {houseHoldurls} from '../urls'
import router from '../../../router'

export default {
  get_all_house_holds (context) {
    Axios.get(houseHoldurls.getAllHouseHolds).then(function (response) {
      context.commit('GET_ALL_HOUSE_HOLDS', response.data)
    })
  },
  get_setting_household (context, publicId) {
    Axios.get(houseHoldurls.getSettingHousehold + publicId).then(function (response) {
      context.commit('GET_ALL_HOUSE_HOLDS', response.data)
    })
  },
  get_house_holds (context, publicId) {
    Axios.get(houseHoldurls.getHouseHolds + publicId).then(function (response) {
      context.commit('GET_HOUSE_HOLDS', response.data)
    })
  },
  get_deleted_house_holds (context) {
    Axios.get(houseHoldurls.getDeletedHouseHold).then(function (response) {
      context.commit('GET_DELETED_HOUSE_HOLDS', response.data)
    })
  },
  get_house_hold (context, publicId) {
    Axios.get(houseHoldurls.getHouseHold + publicId).then(function (response) {
      context.commit('GET_HOUSE_HOLD', response.data)
    })
  },
  post_house_hold (context, data) {
    Axios.post(houseHoldurls.postHouseHold, data).then(function () {
      context.dispatch('get_all_house_holds')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_house_hold (context, data) {
    Axios.post(houseHoldurls.editHouseHold, data).then(function () {
      context.dispatch('get_all_house_holds')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_house_hold (context, publicId) {
    Axios.get(houseHoldurls.deleteHouseHold + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_HOUSE_HOLDS', response.data)
      router.push({
        name: 'Module.DeletedHouseHolds'
      })
    })
  },
  restoreHouseHold (context, publicId) {
    Axios.get(houseHoldurls.restoreHouseHold + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_HOUSE_HOLDS', response.data)
      router.push({
        name: 'Module.HouseHolds'
      })
    })
  }
}
